import type { TLanguage } from '~/types/language';

/*
These are used only in nuxt config for pages and sitemap generating
*/
let _defaultLocale = 'en';
if (process.env.GEO === 'it') {
  _defaultLocale = 'it';
}

if (process.env.GEO === 'de-ch') {
  _defaultLocale = 'de';
}
export const defaultLocale = _defaultLocale;

export const locales: TLanguage[] = ['en', 'de', 'fr', 'it', 'et', 'fi'];

export const siteMapLocales: TLanguage[] = ['en', 'de', 'fr', 'it'];

if (process.env.BRANCH?.startsWith('DEV') || process.env.BRANCH?.startsWith('dev')) {
  if (!process.env.DEFAULT_BACKEND_HOST) {
    process.env.DEFAULT_BACKEND_HOST = 'https://dev.7bitcasino.com/backend';
  }
  if (!process.env.NUXT_REWRITE_STRAPI_HOST) {
    process.env.NUXT_REWRITE_STRAPI_HOST = 'https://dev.7bitcasino.com/strapi';
  }
} else if (process.env.BRANCH?.startsWith('rc')) {
  if (!process.env.DEFAULT_BACKEND_HOST) {
    process.env.DEFAULT_BACKEND_HOST = 'https://stage.7bitcasino.com/backend';
  }
  if (!process.env.NUXT_REWRITE_STRAPI_HOST) {
    process.env.NUXT_REWRITE_STRAPI_HOST = 'https://stage.7bitcasino.com/strapi';
  }
}

export const defaultHostname = process.env.DEFAULT_HOST || 'https://7bitcasino.com';

export const defaultCmsHost = process.env.DEFAULT_CMS_HOST || 'https://dinamic-content.7bitcdn.com';

export const defualtBackendHostname =
  process.env.DEFAULT_BACKEND_HOST || `https://7bitcasino.com/backend`;

export const defaultProvidersCmsUrl = defaultCmsHost + '/providers?_limit=1000';

export const defaultCategoriesCmsUrl = defaultCmsHost + '/category-pages?_limit=1000';

export const defaultInfoCmsUrl = defaultCmsHost + '/info-pages?_limit=1000';

export const defaultBlogCmsUrl = defaultCmsHost + '/blog-pages?_limit=1000';

export const defaultRacesCmsUrl = defaultCmsHost + '/races-pages?_limit=1000';

export const defaultIndexCmsUrl = defaultCmsHost + '/index-pages?_limit=1000';

export const estonianLicenseLocales = ['et', 'fi'];

export const defaultStag = '157007_64b7c4919e586b6b8ff0a593';

export const defaultStagRaw = '157007';

export const stagAfter14days = '159170_noclickid';
